import React, { useEffect, useState } from "react";
import {
  // CustomAutoComplete,
  CustomDropDown,
  CustomForm,
  CustomInput,
} from "shared/AllInputs";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import formValidation from "utils/validations";
import CustomOverlay from "shared/CustomOverlay";
import CustomModal from "shared/Modals/CustomModal";
import { useDispatch, useSelector } from "react-redux";
import { handleDelete } from "shared/Components/commonFunctions";
import {
  BankPurposeOpt,
  LocationOptions,
  YesNoOptions,
} from "shared/AllDropDownOptions";
import {
  deleteBankAccountAction,
  // getBankAccountListAction,
  getLandlordAction,
  getPropertyLandlordAction,
  unlinkBankAccountAction,
  updateBankAccountAction,
} from "store/actions/landlordActions";
import { useLocation, useParams } from "react-router-dom";
import CrossIcon from "assets/images/svg/cross-icon.svg"
import SaveIcon from "assets/images/svg/Save-icon.svg"
// import { debounce } from "lodash";
// import { debounce } from "lodash";
// import { checkIban } from "services/api";
// import { KEYS } from "utils/keys";

export default function CustomBankAccountTable({
  // action,
  id,
  title,
  allBankAccounts,
  setAllBankAccounts,
  onUpdate,
  onDelete,
  landlordId,
  contractId
}) {
  const params = useParams();
  const location = useLocation()
  const pathSegments = location?.pathname.split('/');
  const action = pathSegments[2]
  const dispatch = useDispatch();
  const [editingRows, setEditingRows] = useState({});
  const [deleteModal, setDeleteModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [idToDelete, setIdToDelete] = useState({ id: "", index: "" });
  const [ibanError, setIbanError] = useState("");
  const [isSearch, setIsSearch] = useState(false);
  const { profile } = useSelector((state) => state?.user);
  const [purposeOptions, setPurposeOptions] = useState(BankPurposeOpt)
  // const [selectedBankAccount, setSelectedBankAccount] = useState({ index: "", account: "" });
  // const [bankOptions, setBankOptions] = useState([]);


  const PurposeEditor = (options) => {
    const formErrors = formValidation(
      "purpose",
      options.value,
      allBankAccounts
    );
    return (
      <>
        <CustomDropDown
          value={options.value}
          onChange={(e) => {
            options.editorCallback(e.target.value);
          }}
          name="purpose"
          col={12}
          options={purposeOptions}
          ignoreLabel
          errorMessage={formErrors["purpose"]}
        />
      </>
    );
  };

  const DebitEditor = (options) => {
    const formErrors = formValidation(
      "direct_debit",
      options.value,
      allBankAccounts
    );
    return (
      <>
        <CustomDropDown
          value={options.value}
          onChange={(e) => {
            options.editorCallback(e.target.value);
          }}
          name="direct_debit"
          col={12}
          options={YesNoOptions}
          ignoreLabel
          errorMessage={formErrors["direct_debit"]}
        />
      </>
    );
  };

  const OwnerNameEditor = (options) => {
    const formErrors = formValidation(
      "owner_name",
      options.value,
      allBankAccounts
    );

    return (
      <>
        <CustomInput
          value={options.value}
          col={12}
          onChange={(e) => {
            options.editorCallback(e.target.value);
          }}
          name="owner_name"
          ignoreLabel
          errorMessage={formErrors["owner_name"]}
        />
      </>
    );
  };

  // const handleIban = async (value) => {
  //   if(value){
  //     let payload = {
  //       api_key: KEYS.iBan,
  //       iban: value,
  //     };
  //     const res = await checkIban(payload);

  //     if (res?.data?.is_valid) {
  //       return "";
  //     } else if (!res?.data?.is_valid) {
  //        return "Please enter a valid Iban!";
  //     }
  //   }
  // };

  // const handleIbanChange = useRef(debounce(async (value, onError) => {
  //   const error = await handleIban(value);
  //   onError(error)
  //   setIsSearch(false)
  // }, 1000));

  const IBANEditor = (options) => {
    let formErrors = formValidation("iban", options.value, allBankAccounts);
    return (
      <CustomInput
        value={options.value}
        onChange={(e) => {
          options.editorCallback(e.target.value);
          // handleIbanChange.current(e.target.value, (setIbanError));
          // options.value? setIsSearch(true) : setIsSearch(false)
        }}
        name="iban"
        col={12}
        options={LocationOptions}
        ignoreLabel
        errorMessage={formErrors["iban"] || ibanError}
        isSearch={isSearch}
        disabled
      />
      // value?.iban && setSelectedBankAccount({ index: options?.rowIndex, account: value })
      // handleChangeNew(
      //   e?.target?.name,
      //   value?.iban || value,
      //   index,
      //   allBankAccounts,
      //   setAllBankAccounts,
      //   ignoreInputs
      // );
      // <CustomAutoComplete
      //   field={"name"}
      //   value={options.value}
      //   onChange={(e) => {
      //     {
      //       const value = e.target.value?.iban || e.target.value
      //       options.editorCallback(value);
      //       setSelectedBankAccount({index: options?.rowIndex,  account: e.target.value })
      //     }
      //   }}
      //   name="iban"
      //   suggestions={bankOptions}
      //   editable
      //   panelClassName="dropdown-option-color"
      //   placeholder="Enter IBAN"
      //   ignoreLabel
      //   extraClassName="w-full"
      //   // col={12}
      //   search={(e) => ibanChange.current(e.query)}
      //   errorMessage={formErrors["iban"] || ibanError}
      // />
    );
  };

  const BICEditor = (options) => {
    const formErrors = formValidation("bic", options.value, allBankAccounts);
    return (
      <CustomInput
        value={options.value}
        onChange={(e) => {
          options.editorCallback(e.target.value);
        }}
        name="bic"
        col={12}
        ignoreLabel
        errorMessage={formErrors["bic"]}
      />
    );
  };

  const actions = (rowData, options) => {
    return (
      <>
        {options.rowEditor?.editing ? (
          <>
            <a
              className="cursor-pointer"
              onClick={(e) => handleSave(rowData, options, e)}
            >
              <img src={SaveIcon} />
            </a>
            <a
              className="cursor-pointer"
              onClick={(e) =>
                options.rowEditor?.onCancelClick &&
                options.rowEditor?.onCancelClick(e)
              }
            >
              {" "}
              <img src={CrossIcon} />
            </a>
          </>
        ) : (
          <>
            <CustomOverlay>
              <ul className="no-style p-0">
                <li
                  className="flex gap-2 text-xs font-medium mb-3 cursor-pointer"
                  onClick={() => handleEditRow(rowData)}
                >
                  <i className="pi pi-file-edit text-dark"></i>
                  Edit
                </li>
                <li className="flex gap-2 text-xs font-medium mb-3 cursor-pointer"
                  onClick={() => {
                    setIdToDelete({
                      id: rowData?.id,
                      index: options?.rowIndex,
                    });
                    setDeleteModal(true);
                  }}>
                  <i
                    className="pi pi-trash  text-dark"

                  ></i>{" "}
                  Delete
                </li>
              </ul>
            </CustomOverlay>
          </>
        )}
      </>
    );
  };

  const handleEditRow = (rowData) => {
    const val = { ...{ [`${rowData?.id}`]: true } };
    setEditingRows(val);
  };

  const rowEditValidator = async (rowData, options) => {
    const { purpose, direct_debit, owner_name, iban, bic } = rowData;
    const purposeError = formValidation("purpose", purpose, allBankAccounts);
    const debitError = formValidation("direct_debit", purpose, allBankAccounts);
    const ownerNameError = formValidation(
      "owner_name",
      owner_name,
      allBankAccounts
    );
    const ibanError = formValidation("iban", iban, allBankAccounts);
    const bicError = formValidation("bic", bic, allBankAccounts);
    if (
      !purposeError["purpose"] &&
      !ownerNameError["owner_name"] &&
      !ibanError["iban"] &&
      !bicError["bic"] &&
      !debitError["direct_debit"]
      // && !ibanError
      // && !isSearch
    ) {
      let payload = {
        purpose: purpose,
        direct_debit: direct_debit,
        owner_name: owner_name,
        iban: iban,
        bic: bic,
        landlord: landlordId,
      };
      if (onUpdate) {
        onUpdate(rowData?.id, payload, (res) => {
          if (res) {
            let accounts = [...allBankAccounts];
            accounts[options.rowIndex] = rowData;
            setAllBankAccounts(accounts);
            setEditingRows({});
          }
        });
      } else {
        dispatch(
          updateBankAccountAction(rowData?.id, payload, dispatch, (res) => {
            let accounts = [...allBankAccounts];
            accounts[options.rowIndex] = rowData;
            setAllBankAccounts(accounts);
            setEditingRows({});
            handleGetInfo();
          })
        );
      }
    } else {
      return false;
    }
  };

  const handleSave = async (rowData, options, e) => {
    options?.rowEditor?.onSaveClick(e);
    const val = { ...{ [`${rowData?.id}`]: true } };
    setEditingRows(val);
  };

  const onRowEditChange = (e) => {
    setEditingRows(e.data);
  };

  const handleDeleteBankAccount = () => {
    if (onDelete) {
      onDelete(idToDelete?.id, (res) => {
        if (res) {
          handleDelete(
            allBankAccounts,
            setAllBankAccounts,
            "",
            "",
            idToDelete?.index
          );
          setIdToDelete({ id: "", index: "" });
          setDeleteModal(false);
          handleGetInfo();
        }
      });
    } else {
      if (action === "property") {
        dispatch(
          unlinkBankAccountAction(contractId, idToDelete?.id, setLoading, dispatch, (res) => {
            handleDelete(
              allBankAccounts,
              setAllBankAccounts,
              "",
              "",
              idToDelete?.index
            );
            setIdToDelete({ id: "", index: "" });
            setDeleteModal(false);
            handleGetInfo();
          })
        );
      } else {
        dispatch(
          deleteBankAccountAction(idToDelete?.id, setLoading, dispatch, (res) => {
            handleDelete(
              allBankAccounts,
              setAllBankAccounts,
              "",
              "",
              idToDelete?.index
            );
            setIdToDelete({ id: "", index: "" });
            setDeleteModal(false);
            handleGetInfo();
          })
        );
      }
    }
  };

  const modalContent = () => {
    return (
      <span>
        Are you sure you want to delete the selected bank account from the list?
        This action cannot be undone.
      </span>
    );
  };

  const handleGetInfo = () => {
    if (action === "property") {
      dispatch(getPropertyLandlordAction(params?.id, dispatch));
    } else if (action === "landlord") {
      dispatch(getLandlordAction(profile?.company, params?.id, dispatch));
    }
  };

  // const getBankAccountsList = (landlordId, iban) => {
  //   dispatch(
  //     getBankAccountListAction(landlordId, iban, (res) => {
  //       setBankOptions(res)
  //     })
  //   );
  // }

  // const ibanChange = useRef(debounce((value) => {
  //   getBankAccountsList(landlordId, value)
  // }, 1000));

  // useEffect(() => {
  //   if (selectedBankAccount?.account?.iban) {
  //         const account = selectedBankAccount?.account
  //         const accounts = [...allBankAccounts]
  //         accounts[selectedBankAccount?.index] = { 
  //           bic: account?.bic, 
  //           direct_debit: account?.direct_debit,
  //           iban: account?.iban,
  //           id: account?.id,
  //           owner_name: account?.owner_name,
  //           purpose: account?.purpose,
  //           landlord: landlordId
  //         }
  //         setAllBankAccounts(accounts)
  //         setSelectedBankAccount({index: "", account: ""})
  //   }
  // }, [selectedBankAccount])

  useEffect(() => {
    const purposeOpt = BankPurposeOpt?.map((option) => {
      const isDisabled = allBankAccounts?.some(account => account?.purpose === option?.value);
      return {
        ...option,
        disabled: isDisabled,
      };
    });
    setPurposeOptions(purposeOpt)

  }, [allBankAccounts]);

  return (
    <CustomForm title={title}>
      <DataTable
        className="col-12 properties-table-list table-error-align"
        value={allBankAccounts}
        editMode="row"
        dataKey="id"
        editingRows={editingRows}
        onRowEditChange={onRowEditChange}
        // onRowEditComplete={onRowEditComplete}
        rowEditValidator={rowEditValidator}
        onRowEditSave={handleSave}
        tableStyle={{ minWidth: "50rem" }}
      >
        <Column
          headerClassName="custom-header"
          field="purpose"
          header="Purpose"
          editor={(options) => PurposeEditor(options)}
        // style={{ width: "200px" }}
        ></Column>
        <Column
          headerClassName="custom-header"
          field="iban"
          header="IBAN"
          editor={(options) => IBANEditor(options)}
          style={{ width: "260px" }}
        ></Column>
        <Column
          headerClassName="custom-header"
          field="direct_debit"
          header="Direct Debit"
          editor={(options) => DebitEditor(options)}
          style={{ "textTransform": "capitalize" }}
        ></Column>
        <Column
          headerClassName="custom-header"
          field="owner_name"
          header="Owner Name"
          editor={(options) => OwnerNameEditor(options)}
        // style={{ width: "200px" }}
        // className="firstletter_capital"
        ></Column>
        <Column
          headerClassName="custom-header"
          field="bic"
          header="BIC"
          editor={(options) => BICEditor(options)}
        // style={{ width: "200px" }}
        // className="firstletter_capital"
        ></Column>
        <Column
          headerClassName="custom-header"
          header="Action"
          rowEditor
          // headerStyle={{ minWidth: "8rem" }}
          // bodyStyle={{ textAlign: "center" }}
          body={(rowData, options) => actions(rowData, options)}
        ></Column>
      </DataTable>
      <CustomModal
        isOpen={deleteModal}
        setIsOpen={setDeleteModal}
        heading={"Delete"}
        body={modalContent}
        submitLabel={"Confirm"}
        onSubmit={handleDeleteBankAccount}
        loading={loading}
      />
    </CustomForm>
  );
}
